<template>
  <ul class="sidebar_nav sidebar_list mt-2">
    <sidebar-menu-item
      :active="$route().current('dashboard.user.home') || $route().current('dashboard.user.setup')"
      :label="trans('dashboard.menu.dashboard')"
      :route-to="{ name: 'dashboard.user.home', params: { id: user.id } }"
      icon="dashboard-icon"
    />

    <sidebar-menu-item
      v-if="$can('integrations.view')"
      :active="$route().current('dashboard.user.integrations*')"
      :label="trans('dashboard.menu.integrations')"
      :route-to="{ name: 'dashboard.user.integrations.show', params: { id: user.id } }"
      icon="integrations-icon"
    />

    <sidebar-menu-item
      v-if="$can('applications.view')"
      :active="$route().current('dashboard.user.applications*')"
      :label="trans('dashboard.menu.applications')"
      :route-to="{ name: 'dashboard.user.applications.show', params: { id: user.id } }"
      icon="applications-icon"
    />

    <sidebar-sub-menu
      v-if="$can('profile.view') || $can('billings.view') || $can('teams.view') || $can('change-logs.view')"
      :key="`account-${$route().current()}`"
      :active="$route().current('dashboard.account*')"
      :label="trans('dashboard.menu.account')"
      icon="#user-profile-icon"
    >
      <sidebar-menu-item
        v-if="$can('profile.view')"
        :active="$route().current('dashboard.account.profile*')"
        :label="trans('dashboard.menu.account_profile')"
        :route-to="{ name: 'dashboard.account.profile.show' }"
        :sub="true"
      />

      <sidebar-menu-item
        v-if="$can('billings.view')"
        :active="$route().current('dashboard.account.billing*')"
        :label="trans('dashboard.menu.account_billing')"
        :route-to="{ name: 'dashboard.account.billing.show' }"
        :sub="true"
      />

      <sidebar-menu-item
        v-if="$can('teams.view')"
        :active="$route().current('dashboard.account.teams*')"
        :label="trans('dashboard.menu.account_teams')"
        :route-to="{ name: 'dashboard.account.teams.index' }"
        :sub="true"
      />

      <sidebar-menu-item
        v-if="$can('change-logs.view')"
        :active="$route().current('dashboard.account.change-logs*')"
        :label="trans('dashboard.menu.account_change_logs')"
        :route-to="{ name: 'dashboard.account.change-logs.index' }"
        :sub="true"
      />
    </sidebar-sub-menu>

    <sidebar-sub-menu
      v-if="$can('support.view')"
      :key="`account-${$route().current()}`"
      :active="$route().current('dashboard.support*')"
      :label="trans('dashboard.menu.support')"
      icon="#customer-service-icon"
    >
      <sidebar-menu-item
        v-if="$can('support.view')"
        :active="
          $route().current('dashboard.support.index') ||
          $route().current('dashboard.support.show') ||
          $route().current('dashboard.support.ticket.create')
        "
        :label="trans('dashboard.menu.support_tickets')"
        :route-to="{ name: 'dashboard.support.index' }"
        :sub="true"
      />
      <sidebar-menu-item
        v-if="$can('support.view')"
        :active="$route().current('dashboard.support.services.index')"
        :label="trans('dashboard.menu.support_services')"
        :route-to="{ name: 'dashboard.support.services.index' }"
        :sub="true"
      />
      <sidebar-menu-item
        v-if="$can('support.view')"
        :active="$route().current('dashboard.support.services.purchases.*')"
        :label="trans('dashboard.menu.support_overview')"
        :route-to="{ name: 'dashboard.support.services.purchases.index' }"
        :sub="true"
      />
    </sidebar-sub-menu>

    <sidebar-menu-item
      v-if="$can('partner.support.view') && user.is_partner_support"
      :active="$route().current('partner-support.tickets*')"
      :label="trans('dashboard.menu.tickets')"
      :route-to="{ name: 'partner-support.tickets.index' }"
      icon="customer-service-icon"
    />

    <sidebar-sub-menu
      v-if="user.is_partner && partnerIsApproved"
      :key="`partners-${$route().current()}`"
      :active="$route().current('dashboard.partner*') && !$route().current('dashboard.partner.support.*')"
      :label="trans('dashboard.menu.partner')"
      icon="#partners-icon"
    >
      <sidebar-menu-item
        :active="$route().current('dashboard.partner.company*')"
        :label="trans('dashboard.menu.partner_profile')"
        :route-to="{ name: 'dashboard.partner.company' }"
        :sub="true"
      />

      <sidebar-menu-item
        :active="$route().current('dashboard.partner.leads*')"
        :label="trans('dashboard.menu.partner_leads')"
        :route-to="{ name: 'dashboard.partner.leads.index' }"
        :sub="true"
      />

      <sidebar-menu-item
        :active="$route().current('dashboard.partner.customers*')"
        :label="trans('dashboard.menu.partner_customers')"
        :route-to="{ name: 'dashboard.partner.customers.show' }"
        :sub="true"
      />

      <sidebar-menu-item
        v-if="user.is_regional_partner"
        :active="$route().current('dashboard.partner.partners*')"
        :label="trans('dashboard.menu.partner_partners')"
        :route-to="{ name: 'dashboard.partner.partners.show' }"
        :sub="true"
      />
    </sidebar-sub-menu>

    <sidebar-menu-item
      :active="$route().current('dashboard.manuals.*')"
      :label="trans('dashboard.menu.manuals')"
      :route-to="{ name: 'dashboard.manuals.index' }"
    icon="business-rules-icon"
    />
  </ul>
</template>

<script setup>
import SidebarMenuItem from '@/components/Dashboard/Sidebar/MenuItem';
import SidebarSubMenu from '@/components/Dashboard/Sidebar/SubMenu';

const props = defineProps({
  user: Object,
});

const partnerIsApproved = props.user.partner?.hasSignedContract;
</script>
